import { RegisterOptions, UseFormReturn } from 'react-hook-form'
import { getMall } from '../../../modules/directory/services/Mall.service'
import { InputSelectAsync } from '../InputSelectAsync/InputSelectAsync.page'

type InputSelectMallProps = {
  form?: UseFormReturn<any, any, undefined>
  isMulti?: boolean
  rule?: RegisterOptions<any, string>
  placeholder?: string
  disabled?: boolean
  name?: string
  onChangeValue?: (_:any)=> void,
}

const InputSelectMall = (props: InputSelectMallProps) => {

  return (
    <InputSelectAsync
      placeholder={props.placeholder ?? "Select mall"}
      fetchApi={getMall}
      payload={{ statuses: ['ACTIVE'] }}
      rule={props.rule ?? { required: true }}
      name={props.name ? props.name : props.isMulti ? 'directories' : 'directory'}
      form={props.form}
      selectOption={(item) => ({
        label: item.directory_name!,
        value: item.id!,
      })}
      isMulti={props.isMulti}
      className="col-span-2"
      disabled={props.disabled}
      onChangeValue={(_: any) => {
        props.onChangeValue?.(_);
      }}
    />
  )
}

export default InputSelectMall